import ScreenLock from '../__constants/lock-screen';

class VideoPopup {
    constructor(btnOpenVideo, popupOverlay, popupClose) {
        this.btnOpenVideo = btnOpenVideo;
        this.popupOverlay = popupOverlay;
        this.popupClose = popupClose;
    }
    openPopup(e) {
        const imageLinkContent = e.currentTarget.parentNode;
        const imageLink = imageLinkContent.parentNode;
        const popupOverlay = imageLink.querySelector(this.popupOverlay);
        const iframe = imageLink.querySelector('iframe');
        const video = imageLinkContent.getAttribute('data-video');
        const videoHost = imageLinkContent.getAttribute('data-host');
        let iframeSrc = '';

        popupOverlay.classList.add('is-active');
        ScreenLock.lock();

        iframeSrc += video;

        if (videoHost === "youtube") {
            iframeSrc += "?autoplay=1";
        }
        else if (videoHost == "vimeo") {
            iframeSrc += "&autoplay=1";
        }
        iframe.setAttribute("src", iframeSrc);
    }
    closePopup(e) {
        const popupWrapper = e.currentTarget.parentNode;
        const popup = popupWrapper.parentNode;
        const iframe = popupWrapper.querySelector("iframe");
        let iframeSrc = iframe.getAttribute("src");
        const autoplayIndexY = iframeSrc.indexOf('?autoplay=1');
        const autoplayIndexV = iframeSrc.indexOf('&autoplay=1');
        if (autoplayIndexY > -1) {
            iframeSrc = iframeSrc.substr(0, autoplayIndexY);
        }
        if (autoplayIndexV > -1) {
            iframeSrc = iframeSrc.substr(0, autoplayIndexV);
        }
        iframe.setAttribute("src", iframeSrc);

        if (popup.classList.contains('is-active')) {
            popup.classList.remove('is-active');
            ScreenLock.unlock();
        }
    }
    init() {
        let btnOpenVideo = document.querySelectorAll(this.btnOpenVideo);
        let popupCloseBtns = document.querySelectorAll(this.popupClose);
        if (btnOpenVideo) {
            btnOpenVideo = Array.prototype.slice.call(btnOpenVideo);
            btnOpenVideo.forEach((element) => {
                element.addEventListener("click", (e) => {
                    this.openPopup(e);
                });
            });
        }

        if (popupCloseBtns) {
            popupCloseBtns = Array.prototype.slice.call(popupCloseBtns);
            popupCloseBtns.forEach((popupCloseBtn) => {
                popupCloseBtn.addEventListener('click', (e) => {
                    this.closePopup(e);
                });
            });
        }
    }
}

export default new VideoPopup('.btn-video', '.popup-overlay', '.popup-wrapper-video .popup-close');